/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Dashboard_Sales_Debtor_Days_AgoInputs */

const vi_dashboard_sales_debtor_days_ago = /** @type {(inputs: Dashboard_Sales_Debtor_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} ngày trước`)
};

/**

* @param {Dashboard_Sales_Debtor_Days_AgoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_debtor_days_ago = /** @type {((inputs: Dashboard_Sales_Debtor_Days_AgoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_Debtor_Days_AgoInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_debtor_days_ago(inputs)
});